import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as Action_Apps from '../actions/apps'
import * as Action_Util from '../actions/util'

import LazyLoad from 'react-lazy-load'
import {NavBar,Icon,Button} from 'antd-mobile'

import FliterMenu from './apps/FliterMenu' 

const objectAssign = require('object-assign');

const server = window.server || "";

class Apps extends React.Component {
    constructor(props) {
		super(props);
        const {actions} = props;
		actions.setScrollHeight(1.8);
        props.list.length == 0 && actions.initApps();
    }
    componentDidMount(){
        const {scrollTop} = this.props;
    	document.getElementsByClassName('csm-scroll-wapper')[0].scrollTop = scrollTop
    }
    componentDidUpdate(prevProps) {
        prevProps.list.length == 0 && this.props.list.length > 0 && this.reSetHeight();
        prevProps.scrollTop != this.props.scrollTop && (document.getElementsByClassName('csm-scroll-wapper')[0].scrollTop = this.props.scrollTop)
    }
    render() {
        let that = this;
        const {list,actions,typeDatas,indDatas,moduleDatas,params,openFliter,pageLoading,maxPage,location,height,router,scrollHeight} = this.props;
        const {type,typeName,ind,indName,module,moduleName,current} = params;
        const me = !!localStorage.me ? JSON.parse(localStorage.me) : {com:""};
        const isNotLogin = me.com == '';
		return (
            <div className='csm-body-wapper'>
                <NavBar iconName="user" onLeftClick={this.goRoute.bind(this, isNotLogin ? '/register' :'/user')}
                    rightContent={
                        <span className="csm-navbar-right-icon" onClick={this.goRoute.bind(this,'/search')}>
                    		<Icon type="search" />
                        </span>}>
                    泛微云应用商店
                </NavBar>
                <div className="csm-filter-menu">
                    <FliterMenu 
                        onClick={()=>actions.doMenuChange("module")}
                        onSelected={(id,name)=>actions.doFliter({"module":id,"moduleName":name})}
                        current={module} 
                        datas={moduleDatas} 
                        name={moduleName}
                        defaultName="类型筛选"
                        scrollHeight={scrollHeight}
                        isOpen={openFliter==="module"} />
                    <FliterMenu 
                        onClick={()=>actions.doMenuChange("ind")}
                        onSelected={(id,name)=>actions.doFliter({"ind":id,"indName":name})}
                        current={ind} 
                        datas={indDatas} 
                        name={indName}
                        defaultName="行业筛选"
                        scrollHeight={scrollHeight}
                        isOpen={openFliter==="ind"} />
                    <FliterMenu 
                        onClick={()=>actions.doMenuChange("type")}
                        onSelected={(id,name)=>actions.doFliter({"type":id,"typeName":name})}
                        current={type} 
                        datas={typeDatas} 
                        name={typeName}
                        defaultName="排序方式"
                        scrollHeight={scrollHeight}
                        isOpen={openFliter==="type"} />
                    
                </div>
                <div className='csm-scroll-wapper' style={{height:scrollHeight}} 
                    onTouchEnd={()=>{
                    	let parent = document.getElementsByClassName('csm-scroll-wapper')[0];
	                    let child = parent.getElementsByClassName('csm-app-list')[0];
	                    if(this.getLoadBool(parent,child) && current < maxPage) {
	                        actions.goNextPage({current:current + 1});
	                    }
                    }}>
                    <div className="csm-app-list">
                    {
                        list && list.map(e => {
                            return (
                                <div className="csm-app-list-each" onClick={this.goRoute.bind(this,'/app/'+e.sw_id)}>
                                    <LazyLoad height={height > 270 ? 275 : (height + 5)}> 
                                        <img className="csm-app-img" style={{maxWidth:270,height: height > 270 ? 270 :height}} src={ server + e.s_pictureNati } />
                                    </LazyLoad> 
	                                <div className="csm-app-name">
	                                    <p> { e.s_name } </p>
	                                </div>
                                </div>
                            )
                        })
                    }
                    </div>
                    {pageLoading && <div style={{textAlign:"center",paddingBottom:"20px"}}>
                        <Button loading={true}>加载中</Button>
                    </div>}
                    {current>=maxPage &&!pageLoading && <div style={{textAlign:"center",paddingBottom:"20px"}}>
                        <Button onClick={this.getAllOrScroll.bind(this)}>{!!params.searchValue ? '查看全部' : (maxPage == 0 ? '没有数据' : '加载完成')}</Button>
                    </div>}
                </div>
            </div>
        )
    }
    goRoute(path){
    	const {actions,router} = this.props;
    	actions.resetScrollTop(document.getElementsByClassName('csm-scroll-wapper')[0].scrollTop);
    	router.push(path);
    }
    reSetHeight() {
		const {height,actions} = this.props;
		let boxes = document.getElementsByClassName('csm-app-list-each');
		if(!!boxes && boxes.length !== 0){
			let imgW = boxes[0].offsetWidth * 0.72;
			let h = imgW > 270 ? 270 : imgW;
			actions.resetHeight(h);
		}
	}
    getAllOrScroll(){
    	const {params,actions} = this.props;
		//console.log(!!params.searchValue,params.searchValue);
    	if(!!params.searchValue){
    		actions.resetParams();
    		actions.doMenuChange();
    		actions.getApps();
    	}else{
    		document.getElementsByClassName('csm-scroll-wapper')[0].scrollTop = 0
    	}
    }
    getLoadBool(p,c){
    	if(!p || !c) return false;
		let s = c.scrollHeight;
		let t = p.scrollTop;
		let h = p.offsetHeight;
		return s <= t + h + 10
	}
}

function mapStateToProps(state) {
    const {apps,util} = state;
    return {
    	scrollHeight:util.scrollHeight,
    	scrollTop: apps.scrollTop,
        list: apps.list,
        params: apps.params,
        typeDatas: apps.typeDatas,
        moduleDatas: apps.moduleDatas,
        indDatas: apps.indDatas,
        openFliter: apps.openFliter,
        pageLoading: apps.pageLoading,
        maxPage: apps.maxPage,
        height: apps.height
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(objectAssign({},Action_Apps,Action_Util), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Apps);










// WEBPACK FOOTER //
// ./project/components/Apps.js